/**
 * @generated SignedSource<<b6c9fba13c05c466bcffb71556d951d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityKind = "ALL" | "COMPETITION" | "DATASET" | "EVENT" | "WORKSPACE";
export type TagInputQuery$variables = {
  activityKind?: ActivityKind | null | undefined;
  search?: string | null | undefined;
};
export type TagInputQuery$data = {
  readonly tags: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    }>;
  };
};
export type TagInputQuery = {
  response: TagInputQuery$data;
  variables: TagInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activityKind"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "activityKind",
        "variableName": "activityKind"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TagInputQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "TagConnection",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "TagInputQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "TagConnection",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3244b896861236cf1d08882dcdd86514",
    "id": null,
    "metadata": {},
    "name": "TagInputQuery",
    "operationKind": "query",
    "text": "query TagInputQuery(\n  $search: String\n  $activityKind: ActivityKind\n) {\n  tags(first: 6, filters: {search: $search, activityKind: $activityKind}) {\n    nodes {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "596b6524f36c9199dc2723198f1b0159";

export default node;
